(function(document) {

    var selectors = {
        pageGuide: '.page-guide',
        productBoxList: '.product-simply-box-list',
        productBox: '.product-simply-box',
        sectionDetails: '.product-guide-details',
        scrollTop: '.scroll-top',
        pTitle: '#attr-p_title',
        detailsBoxesAsync: '.details-box--async',
        detailsBoxesUniversal: '.details-box--universal',
        splitboardGuides: '.splitboard-guides',
        productGuideBanner: '.product-guide-details__banner',
        universalBoxes: '.details-box--universal .details-box__content__data',
    };
  
    var pageGuide = document.querySelector(selectors.pageGuide);
    var productBoxList = document.querySelector(selectors.productBoxList);
    var productBoxes = document.querySelectorAll(selectors.productBox);
    var sectionDetails = document.querySelector(selectors.sectionDetails);
    var scrollTop = document.querySelector(selectors.scrollTop);
    var pTitle = document.querySelector(selectors.pTitle);
    var detailsBoxesAsync = document.querySelectorAll(selectors.detailsBoxesAsync);
    var detailsBoxesUniversal = document.querySelectorAll(selectors.detailsBoxesUniversal);
    var splitboardGuides = document.querySelector(selectors.splitboardGuides);
    var productGuideBanner = document.querySelector(selectors.productGuideBanner);
    var universalBoxes = document.querySelectorAll(selectors.universalBoxes);
  
    function readAll(async) {

        if (async == "async") {
            loopDetailsBoxes = detailsBoxesAsync
        } else {
            loopDetailsBoxes = detailsBoxesUniversal
        }

        //loopDetailsBoxes.forEach(function(detailsBox) {
            // var textTruncate = detailsBox.querySelector('.text-truncate')
            // var textFull = detailsBox.querySelector('.text-full')
            // var readAll = detailsBox.querySelector('.read-all')
            // var readAllText = detailsBox.querySelector('.read-all__text')
            // if (readAll) {
            //     readAll.addEventListener("click", function(){
            //         console.log(async)
            //         if (this.classList.contains('read-less')) {
            //             textTruncate.classList.remove('hide')
            //             textFull.classList.add('hide')
            //             this.classList.remove('read-less')
            //             readAllText.innerHTML = "Read More";
            //         } else {
            //             textTruncate.classList.add('hide')
            //             textFull.classList.remove('hide')
            //             this.classList.add('read-less')
            //             readAllText.innerHTML = "Read Less";
            //         }
            //     })
            // }
        //})
    }

    if (productBoxList) {
        productBoxes.forEach(function(productBox) {
            productBox.addEventListener("click", function(event) {

                if(!event.detail || event.detail == 1){

                    console.log("guide check")
                    // START Empty content
                    var boxesSpecifics = document.querySelectorAll('.details-box__content__data--specific')
                    boxesSpecifics.forEach(box => {
                        box.remove();
                    });
    
                    var boxesContent = document.querySelectorAll('.details-box__content')
                    boxesContent.forEach(boxContent => {
                        boxContent.classList.add('closed')
                        var arrow = boxContent.querySelector("i")
                        arrow.classList.remove('open')
                    });
    
                    document.querySelector('.product-guide-details__hero__image').innerHTML = "";
                    document.querySelector('.banner-box__text__col1').innerHTML = "";
                    document.querySelector('.banner-box__text__col2').innerHTML = "";
                    document.querySelector('.banner-box__image__videos').innerHTML = "";
                    document.querySelector('.banner-box__image__select').innerHTML = "";

                    document.querySelectorAll('.js-guide-step-on-text').forEach(step_on_content_text => {
                        step_on_content_text.innerHTML = ""
                    });
                    document.querySelectorAll('.js-guide-step-on-video').forEach(step_on_content_video => {
                        step_on_content_video.innerHTML = ""
                    });
                    document.querySelector('.js-step-on-content').classList.add("hide")
                    document.querySelector('.details-box.details-box--async[data-custom="2"]').classList.remove("hide")
                    document.querySelector('.details-box.details-box--async[data-custom="4"]').classList.remove("hide")
                    document.querySelector('.details-box.details-box--async[data-custom="5"]').classList.remove("hide")
                    document.querySelector('.details-box.details-box--async[data-custom="6"]').classList.remove("hide")
                    document.querySelector('.details-box.details-box--async[data-custom="7"]').classList.remove("hide")
                    document.querySelector('.details-box.details-box--async[data-custom="8"]').classList.remove("hide")
                    document.querySelector('.details-box__content__data--bindings-disk--media').classList.remove("hide")
                    document.querySelector('.details-box__content__data--bindings-stance--media').classList.remove("hide")
                    document.querySelector('.details-box__content__data--bindings-width--media').classList.remove("hide")
                    
                    // END Empty content
    
                    sectionDetails.classList.add('hide')
                    document.querySelectorAll('.banner-box__image__disk').forEach(function(image_disk){
                        image_disk.classList.add("hide")
                        image_disk.classList.add("hidden")
                    })
    
                    var p_handle = this.getAttribute("attr-p_handle")
                    var p_image = this.getAttribute("attr-p_img")
                    var p_title = this.getAttribute("attr-p_title")
    
                    // console.log(p_handle)
    
                    var splitboards = "union-charger-unisex-splitboard-binding-2027, union-explorer-unisex-splitboard-binding-2027, union-charger-fc-unisex-splitboard-binding-2027"
                    var explorer = "union-explorer-unisex-splitboard-binding-2027"
                    var otherSplitboards = "union-charger-unisex-splitboard-binding-2027, union-charger-fc-unisex-splitboard-binding-2027"
                    
                    if (splitboards.includes(p_handle)) {
                        splitboardGuides.classList.add("show")
                        productGuideBanner.classList.add("hide")
                    } else {
                        splitboardGuides.classList.remove("show") 
                        productGuideBanner.classList.remove("hide")
                    }
    
                    if (explorer.includes(p_handle)) {
                       document.querySelector('.details-box[data-custom="24"]').classList.add("show")
                    } else {
                        document.querySelector('.details-box[data-custom="24"]').classList.remove("show")
                    }
                    
                    if (otherSplitboards.includes(p_handle)) {
                        document.querySelector('.details-box[data-custom="25"]').classList.add("show")
                     } else {
                         document.querySelector('.details-box[data-custom="25"]').classList.remove("show")
                    }

                    universalBoxes.forEach((universalBox) => {
                        let dataType = universalBox.getAttribute("data-type")
                        if (splitboards.includes(p_handle)) {
                            if (dataType == "splitboard") {
                                universalBox.classList.remove("hide")
                            } else {
                                universalBox.classList.add("hide")
                            }
                        } else {
                            if (dataType == "normal") {
                                universalBox.classList.remove("hide")
                            } else {
                                universalBox.classList.add("hide")
                            }
                        }
                    })

                    let remote_url = "https://eu.unionbindingcompany.com/pages/finder-list?view=product-metafields.json"

                    var stepOnHandles = "union-astra-step-on-womens-snowboard-binding-2027, union-atlas-step-on-mens-snowboard-binding-2027, union-atlas-pro-step-on-mens-snowboard-binding-2027"
                    if (stepOnHandles.includes(p_handle)) {
                        remote_url = "https://eu.unionbindingcompany.com/pages/finder-list?view=product-metafields-step-on.json"
                    }
    
                    jQuery.ajax({
                        url: remote_url, 
                        success:function(products) {
    
                            var products_list = JSON.parse(products)
    
                            for (var nome_attacco of Object.keys(products_list)) {
                  
                              if(p_handle == nome_attacco) {
    
                                products_list[nome_attacco].forEach((values,i) => { 
    
                                    const valuesArray = values.split("$$$$");
                                    var linkVideo = valuesArray[0]
                                    var textContent = valuesArray[1]
                                    // var textTruncate = textContent.substring(0, 200)+'...';

                                    // console.log(valuesArray)
    
                                    if (valuesArray[0] == '%%banner%%') {
    
                                        if (!splitboards.includes(p_handle)) {
                                            var guide_banner_text_col1 = valuesArray[1] ? valuesArray[1] : "No Mounting guide."
                                            // var guide_banner_text_col2 = valuesArray[2] ? valuesArray[2] : document.querySelector('.tech-tip-js').style("display", "none")
                                            document.querySelector('.banner-box__text__col1').insertAdjacentHTML( 'beforeend', guide_banner_text_col1);
                                            // document.querySelector('.banner-box__text__col2').insertAdjacentHTML( 'beforeend', guide_banner_text_col2); 
                                            if (valuesArray[2] == "") { 
                                                document.querySelector('.tech-tip-js').style.display = "none"
                                            } else {
                                                document.querySelector('.tech-tip-js').style.display = "block"
                                            }
                                        } 
                                        
                                    } else if (valuesArray[0] == '%%hero%%') {
                                        // var guide_hero_image = valuesArray[1] ? valuesArray[1] : "https://cdn.shopify.com/s/files/1/0296/3764/0285/files/Schermata_2022-06-13_alle_08.46.40.png?v=1655102812"
                                        var guide_hero_image = p_image
                                        
                                        var dataContent__HeroImage = `<img src="`+guide_hero_image+`" alt="union guide" >`
    
                                        document.querySelector('.product-guide-details__hero__image').insertAdjacentHTML( 'beforeend', dataContent__HeroImage);
    
                                    } else if (valuesArray[0] == '%%disks_option%%') {
    
                                        // console.log(valuesArray[1])
                                        var guide_disks = valuesArray[1].replace('["','').replace('"]','').split('", "')
                                        // console.log(guide_disks)
    
                                        guide_disks.forEach(function(guide_disk, index) {
                                            document.querySelector('.banner-box__image__select').insertAdjacentHTML( 'beforeend', '<option value="'+index+'">'+guide_disk+'</option>')
                                        })
    
                                        document.querySelector('.banner-box__image__select').addEventListener("change", function(select_disk){
                                            // console.log(select_disk.target.value)
                                            var attr_video_disk = select_disk.target.value
                                            document.querySelectorAll('.banner-box__image__video').forEach(function(image_disk){
                                                image_disk.classList.add("hide")
                                            })
                                            document.querySelector('.banner-box__image__video[attr-video-disk="'+attr_video_disk+'"]').classList.remove("hide")
                                        });
    
                                    } else if (valuesArray[0] == '%%disks_video%%') {
    
                                        var guide_disks_video = valuesArray[1].replace('["','').replace('"]','').split('", "')
    
                                        guide_disks_video.forEach(function(guide_disk_video, index) {
                                            
                                                if (index == 0) {
                                                    document.querySelector('.banner-box__image__videos').insertAdjacentHTML( 'beforeend', '<video class="banner-box__image__video" attr-video-disk="'+index+'" width="500" height="500" controls><source src="'+guide_disk_video+'" type="video/mp4"></video>')
                                                } else {
                                                    document.querySelector('.banner-box__image__videos').insertAdjacentHTML( 'beforeend', '<video class="hide banner-box__image__video" attr-video-disk="'+index+'" width="500" height="500" controls><source src="'+guide_disk_video+'" type="video/mp4"></video>')
                                                }
                                            })
    
    
                                    } else if (valuesArray[0] == '%%step_on_text%%') {

                                        document.querySelector('.js-step-on-content').classList.remove("hide")
                                        document.querySelector('.details-box.details-box--async[data-custom="2"]').classList.add("hide")
                                        document.querySelector('.details-box.details-box--async[data-custom="4"]').classList.add("hide")
                                        document.querySelector('.details-box.details-box--async[data-custom="5"]').classList.add("hide")
                                        document.querySelector('.details-box.details-box--async[data-custom="6"]').classList.add("hide")
                                        document.querySelector('.details-box.details-box--async[data-custom="7"]').classList.add("hide")
                                        document.querySelector('.details-box.details-box--async[data-custom="8"]').classList.add("hide")
                                        document.querySelector('.details-box__content__data--bindings-disk--media').classList.add("hide")
                                        document.querySelector('.details-box__content__data--bindings-stance--media').classList.add("hide")
                                        document.querySelector('.details-box__content__data--bindings-width--media').classList.add("hide")
    
                                        const step_on_text__split = valuesArray[1].split("££££");

                                        var step_on_text = valuesArray[1].replace('["','').replace('"]','').split('", "')

                                        document.querySelectorAll('.js-guide-step-on-text').forEach(function(guide_step_on_text, i) {
                                            console.log(step_on_text__split[i].replace('["','').replace('"]','').replaceAll("\\", ""))
                                            guide_step_on_text.insertAdjacentHTML( 'beforeend', step_on_text__split[i].replace('["','').replace('"]','').replaceAll("\\", "").split('", "'))
                                        })
                                            
                                            
                                       
                                    } else if (valuesArray[0] == '%%step_on_video%%') {

                                        var step_on_video__split = valuesArray[1].split('££££')
         
                                        document.querySelectorAll('.js-guide-step-on-video').forEach(function(guide_step_on_video, i) {
                                            guide_step_on_video.insertAdjacentHTML( 'beforeend', '<video class=" banner-box__image__video" attr-video-step-on="'+i+'" width="500" height="500" controls><source src="'+step_on_video__split[i].replace('["','').replace('"]','').split('", "')+'" type="video/mp4"></video>')
                                        })
    
                                    } else {
    
                                        if (textContent) {
                                            var dataText = `                               
                                                <div class="text-full normal">`+textContent+`</div>    
                                                <a class="read-all hide"><img src="//cdn.shopify.com/s/files/1/0296/3764/0285/t/7/assets/arrow-right-bottom.png?v=144182443733051307411623869390" alt="union arrow"><span class="read-all__text">Read More</span></a>
                                            `
                                        } else {
                                            var dataText = `<p>No guide to show.</p>`
                                        }
    
                                        var dataVideo = ``
                                        if (linkVideo) {
                                            if (linkVideo.toLowerCase().includes(".mp4")) {
                                                dataVideo = `                               
                                                    <video controls>
                                                        <source src="`+linkVideo+`" type="video/mp4">
                                                    </video>
                                                `
                                            } else {
                                                dataVideo = `                               
                                                    <img src="`+linkVideo+`" alt="video union bindings guide">
                                                `
                                            }
                                        } 
    
                                        var dataContent = `       
                                            <div class="details-box__content__data details-box__content__data--specific">                             
                                                `+dataText+`
                                                `+dataVideo+`
                                            </div>
                                            `
                                        
                                        let detailBox = document.querySelector('.details-box[data-custom="'+i+'"] .details-box__content')
                                        if (detailBox) {
                                            detailBox.insertAdjacentHTML( 'beforeend', dataContent);
                                        }
                                        
                                    }
    
                                })
    
                              }
                            }
    
                            pTitle.innerHTML = p_title
                                                    
                            sectionDetails.classList.remove('hide')
                            sectionDetails.scrollIntoView({ behavior: 'smooth', block: 'start'});
    
                            readAll("async")
    
                        }
                    })
                }


                

            });
        })

        scrollTop.addEventListener("click", function(){
            pageGuide.scrollIntoView({ behavior: 'smooth', block: 'start'});
        });

        readAll("universal")

    }
    


})(document);
  